export default {
	getItems: state => state.items,
	getTimeline: state => state.timeline,
	getHoldingType: state =>state.holding_type,
	getIsHistory: state =>state.is_history,
}